import React, { useContext } from 'react';
import { useLocation } from '@gatsbyjs/reach-router';
import { enrollmentContext } from '../../context/enrollment/enrollment-context';
import { PizzaTracker } from '../pizza-tracker';
import { basePath } from '../../../domains/flow/flow';
import useTranslation from '../../../../hooks/useTranslation';
import useForms, { Form } from '../../../../hooks/useForms';
import useProduct from '../../../../hooks/useProduct';

// TODO hardcoded uris or dependencies on flow constants are not desired
// Need to find another way to define the tracker steps
// For instance, make each flow add the steps to the tracker on Flow creation
export const EnrollmentTracker: React.FC<{}> = () => {
	const product = useProduct();
	const enrollmentCtxt = useContext(enrollmentContext);
	const forms = useForms().filterForms();
	const { t } = useTranslation();
	const location = useLocation();
	const urls = forms?.map((form: Form, index: number) => {
		return {
			label: t(`forms.${form.id}.label`),
			link: basePath + '/forms/' + (index + 1),
		};
	});
	urls.push(
		...[
			{ link: basePath + '/forms/review', label: t('pages.review.label') },
			{
				link: basePath + '/confirmation/loading',
				label: t('pages.confirmation.label'),
			},
		]
	);
	const position = urls.findIndex((url) => {
		return location.pathname.includes(url.link);
	});
	return (
		<>
			{position > -1 && !enrollmentCtxt.isFastTrack(product) && (
				<div className="flex justify-center">
					<PizzaTracker urls={urls} current={position} />
				</div>
			)}
		</>
	);
};
